import {
  RegExExtractUrlsWithNoAnchorTagsFromSmsText,
  MaxNumberOfLinksToBeShorten
} from '../constants';
import { Sms } from '../utilities/sms';

export function addAnchorTagsToLinks(text: string, clickable = false) {
  const smsTextWithHtmlLinks = text.replace(
    RegExExtractUrlsWithNoAnchorTagsFromSmsText,
    match => {
      return (
        (match.startsWith(' ') ? ' ' : '') +
        `<a href=${
          clickable
            ? '"' + match.trim() + '?analytics=false" target="_blank"'
            : '"javascript:;"'
        }>${match.trim()}</a>` +
        (match.endsWith(' ') ? ' ' : '')
      );
    }
  );

  return smsTextWithHtmlLinks;
}

export function smsTextWithShortenLinks(
  text: string,
  defaultShortenLink: string
) {
  const shortenedLinksAndSmsText = new Sms(
    text
  ).extractAndShortenLinksInSmsText(
    MaxNumberOfLinksToBeShorten,
    defaultShortenLink
  );

  return shortenedLinksAndSmsText;
}
